"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
exports.ConfigSchema = _imports_1.z.object({
    configKey: _imports_1.z.string(),
    daysOffset: _imports_1.z.number(),
    recurringDueDateConfig: _imports_1.RecurringDate.ConfigSchema,
});
//# sourceMappingURL=DeliverableProperty.js.map